import { useBasename, useCreatePath, useGetRecordRepresentation, useGetResourceLabel, useResourceDefinition, useTranslate, } from 'react-admin';
/**
 * This hook is used internally to build a resource breadcrumb path map
 * The result is usually used by <ResourceBreadcrumbItem /> to render a BreadcrumbItem tree for a given resource
 *
 * @see ResourceBreadcrumbItem
 */
export var useResourceBreadcrumbPaths = function (resource) {
    var _a;
    var resourceDefinition = useResourceDefinition({
        resource: resource,
    });
    var getResourceLabel = useGetResourceLabel();
    var translate = useTranslate();
    var createPath = useCreatePath();
    var basename = useBasename();
    var getRecordRepresentation = useGetRecordRepresentation(resource);
    var resourceLabelPlural = getResourceLabel(resource, 2);
    var resourceLabelSingular = getResourceLabel(resource, 1);
    var resourcePaths = (_a = {},
        _a[resource] = {
            label: resourceLabelPlural,
            to: "".concat(basename, "/").concat(resource),
        },
        _a["".concat(resource, ".create")] = {
            label: !resourceDefinition.hasList
                ? translate('ra.page.create', {
                    name: resourceLabelSingular,
                })
                : translate('ra.action.create'),
            to: createPath({
                resource: resource,
                type: 'create',
            }),
        },
        _a["".concat(resource, ".edit")] = {
            label: function (_a) {
                var record = _a.record;
                var recordRepresentation = getRecordRepresentation(record);
                if (typeof recordRepresentation !== 'string') {
                    return "#".concat(record.id);
                }
                return !record
                    ? translate('ra.action.edit')
                    : !resourceDefinition.hasList
                        ? translate('ra.page.edit', {
                            name: resourceLabelSingular,
                            id: record.id,
                            record: record,
                            recordRepresentation: recordRepresentation,
                        })
                        : recordRepresentation;
            },
            to: function (_a) {
                var record = _a.record;
                return record
                    ? createPath({
                        resource: resource,
                        id: record.id,
                        type: 'edit',
                    })
                    : '';
            },
        },
        _a["".concat(resource, ".show")] = {
            label: function (_a) {
                var record = _a.record;
                var recordRepresentation = getRecordRepresentation(record);
                if (typeof recordRepresentation !== 'string') {
                    return "#".concat(record.id);
                }
                return !record
                    ? translate('ra.action.show')
                    : !resourceDefinition.hasList
                        ? translate('ra.page.show', {
                            name: resourceLabelSingular,
                            id: record.id,
                            record: record,
                            recordRepresentation: recordRepresentation,
                        })
                        : recordRepresentation;
            },
            to: function (_a) {
                var record = _a.record;
                return record
                    ? createPath({
                        resource: resource,
                        id: record.id,
                        type: 'show',
                    })
                    : '';
            },
        },
        _a);
    return resourcePaths;
};
